import http from './httpService';
import config from './../config.json';

export const adminRegister = (fullName, email, password, adminSecret) => {
    return http.post(`${config.api_admin}/register`,JSON.stringify({ fullName, email, password, adminSecret }));
}

export const adminChangePassowrd = (email, password, adminSecret) => {
    return http.post(`${config.api_admin}/change-password`,JSON.stringify({ email, password, adminSecret }));
}

export const adminLogin = (email, password) => {
    return http.post(`${config.api_admin}/login`, JSON.stringify({email, password}));
}

export const adminLogout = () => {
    return http.delete(`${config.api_admin}/logout`);
    
}
export const authToken = ({cancelToken}) => {
    return http.get(`${config.api_admin}/auth-token`, {cancelToken});
    
}
export const getAllDocumentsCount = ({cancelToken}) => {
    return http.get(`${config.api_admin}/all-documents-count`, {cancelToken});
    
}

